import {makeAutoObservable} from "mobx";
import {AUTO_PROCESS_TRIGGER, AUTO_PROCESS_VALIDATED_QUALIFIER} from "../../../models/User";
import {AUTO_PROCESS_EXECUTE, SINCE_UNIT} from "../../policies/constants";
export interface IAutoRefundDto {
	is_on: boolean,
	trigger: AUTO_PROCESS_TRIGGER | null,
	validated_qualifier?: AUTO_PROCESS_VALIDATED_QUALIFIER | null,
	execute: AUTO_PROCESS_EXECUTE | null,
	since_value?: number | null,
	since_unit?: SINCE_UNIT | null
}
class RmaAutoRefundStore {
	private _model:IAutoRefundDto;
    private _defaults: IAutoRefundDto;
	
	constructor(defaults: IAutoRefundDto) {
		makeAutoObservable(this, {}, {autoBind: true});
		defaults = _ensureValidadModel(defaults);

        this._defaults = { ...defaults };
		this._model = { ...defaults };
	}
	
	get isOn():boolean {return this._model.is_on;}
	get autoRefundTrigger():AUTO_PROCESS_TRIGGER | null { return this._model.trigger; }
	get autoRefundValidatedQualifier():AUTO_PROCESS_VALIDATED_QUALIFIER | null | undefined { return this._model.validated_qualifier; }
	get autoRefundExecute():AUTO_PROCESS_EXECUTE | null { return this._model.execute; }
	get autoRefundSinceValue():number | null | undefined { return this._model.since_value;}
	get autoRefundSinceUnits():SINCE_UNIT | null | undefined { return this._model.since_unit;}
	get shouldDisableResetToDefault(): boolean { return JSON.stringify(this._model) === JSON.stringify({...this._defaults});}
	setIsOn(value:boolean) { this._model.is_on = value; }
	setAutoRefundTrigger(value:AUTO_PROCESS_TRIGGER | null) { this._model.trigger = value; }
	setAutoRefundExecute(value:AUTO_PROCESS_EXECUTE | null) { this._model.execute = value; }
	setAutoRefundValidatedQualifier(value:AUTO_PROCESS_VALIDATED_QUALIFIER | null | undefined) { this._model.validated_qualifier = value; }
	setAutoRefundSinceValue(value: number | null) { this._model.since_value = value; }
	setAutoRefundSinceUnit(value: SINCE_UNIT | null) { this._model.since_unit = value; }
	
	requestModel(){ return {...this._model}; }
    setDefaults() {
        this._model = {...this._defaults};
    }
}

function _ensureValidadModel(model: IAutoRefundDto): IAutoRefundDto {
	const toBool = (v: undefined | any) => Boolean(v);
	
	return {
		...model,
		is_on: toBool(model.is_on),
	}
}

export default RmaAutoRefundStore;